/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';

export interface GetOneBuchung$Plain$Params {

/**
 * ID der Buchung
 */
  buchungsId: string;

/**
 * Flag if soft-deleted Buchungen should be included in the result
 */
  includeDeleted?: boolean;
}

export function getOneBuchung$Plain(http: HttpClient, rootUrl: string, params: GetOneBuchung$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungDto>> {
  const rb = new RequestBuilder(rootUrl, getOneBuchung$Plain.PATH, 'get');
  if (params) {
    rb.path('buchungsId', params.buchungsId, {});
    rb.query('includeDeleted', params.includeDeleted, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungDto>;
    })
  );
}

getOneBuchung$Plain.PATH = '/v1/buchungen/{buchungsId}';
